// cotizacion.js
import axios from "axios";

const state = {
  cotizaciones: [],
};

const mutations = {
  SET_COTIZACIONES(state, cotizaciones) {
    state.cotizaciones = cotizaciones;
  },
  ADD_COTIZACION(state, cotizacion) {
    state.cotizaciones.push(cotizacion);
  },
  UPDATE_COTIZACION(state, cotizacion) {
    const index = state.cotizaciones.findIndex((c) => c.id === cotizacion.id);
    if (index !== -1) {
      state.cotizaciones.splice(index, 1, cotizacion);
    }
  },
  DELETE_COTIZACION(state, cotizacionId) {
    state.cotizaciones = state.cotizaciones.filter(
      (c) => c.id !== cotizacionId
    );
  },
};

const actions = {
  async fetchCotizaciones({ commit }) {
    try {
      const response = await axios.get("/api/cotizacion");
      commit("SET_COTIZACIONES", response.data);
    } catch (error) {
      console.error("Error fetching cotizaciones:", error);
      throw error;
    }
  },
  async getCotizacionById(_, id) {
    try {
      const response = await axios.get(`/api/cotizacion/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo cotización por ID:", error);
      throw error;
    }
  },
  async guardarCotizacion({ commit }, cotizacion) {
    try {
      const response = await axios.post("/api/cotizacion", cotizacion);
      commit("ADD_COTIZACION", response.data);
      return response.data;
    } catch (error) {
      console.error("Error saving cotizacion:", error);
      throw error;
    }
  },
  async updateCotizacion({ commit }, cotizacion) {
    try {
      const response = await axios.put(
        `/api/cotizacion/${cotizacion.id}`,
        cotizacion
      );
      commit("UPDATE_COTIZACION", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating cotizacion:", error);
      throw error;
    }
  },
  async deleteCotizacion({ commit }, cotizacionId) {
    try {
      await axios.delete(`/api/cotizacion/${cotizacionId}`);
      commit("DELETE_COTIZACION", cotizacionId);
    } catch (error) {
      console.error("Error deleting cotizacion:", error);
      throw error;
    }
  },
};

const getters = {
  cotizaciones: (state) => state.cotizaciones,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
